export default "__VITE_ASSET__BQnSXziP__"